import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

type ImageObject = {
  src: string;
};

export interface LightboxElement extends HTMLElement {
  images: ImageObject[];
  visible: boolean;
  onClose: () => void;
  zoomEnabled?: boolean;
  currentIndex?: number;
}

const OpLightbox = createWrapper<LightboxElement>('op-lightbox');

export default OpLightbox;
